// Public imports
import { useTheme } from '@mui/material/styles';

//* Import components
import {
  AutoAwesome,
  Explore,
  MovieCreation,
  Hub,
  Campaign,
  RocketLaunch,
} from '@mui/icons-material';
import { Box, Stack, Typography, alpha } from '@mui/material';
import ValueCard from './ValueCard';

export default function OurValues() {
  // Hooks
  const theme = useTheme();

  const journeyItems = [
    {
      icon: <AutoAwesome />,
      date: 'شروع ماجرا',
      title: 'از یک نیاز ساده تا تولد آدین‌زون',
      desc: `آدین‌زون از یه حس واقعی شروع شد؛
از دلِ نیازهای من به عنوان یه مربی، دانشجو و عاشق ورزش.
می‌دیدم مربی‌ها دنبال فرصت رشدن، باشگاه‌ها دنبال دیده شدن و کسب‌وکارهای ورزشی دنبال جایی مطمئن برای معرفی خودشون.
اونجا بود که تصمیم گرفتم از خودم شروع کنم؛ قدم‌به‌قدم، از دل نیازها و تجربه‌ها، خانواده‌ای ساخته شد به اسم آدین‌زون 💙`,
      gradient: 'linear-gradient(135deg, #667eea, #764ba2)',
      glowColor: '#667eea',
      side: 'right',
    },
    {
      icon: <Explore />,
      date: '۷ آذر ۱۴۰۱',
      title: 'شروع مسیر | کانال مربیگری ورزشی',
      desc: `اولین گام در ۷ آذر ۱۴۰۱ بود؛ جایی که کانال مربیگری ورزشی رو ساختم تا مربی‌ها راحت‌تر مسیر دریافت مدرک رو پیدا کنن، از زمان برگزاری دوره‌ها باخبر بشن و از تجربه‌ی بقیه استفاده کنن.
        اونجا هدف فقط کمک بود؛ یه راه ساده برای رشد و یادگیری.`,
      gradient: 'linear-gradient(135deg, #f093fb, #f5576c)',
      glowColor: '#f093fb',
      side: 'left',
    },
    {
      icon: <MovieCreation />,
      date: '۲۴ آبان ۱۴۰۲',
      title: 'ادامه مسیر | سکانس ورزشی',
      desc: `در ۲۴ آبان ۱۴۰۲، پیج سکانس ورزشی متولد شد.
اولش برای معرفی مربی‌ها و باشگاه‌ها بود، ولی کم‌کم به سمتی رفت که جامعه‌ی ورزش بهش نیاز داشت: تولید محتوای تخصصی ورزشی برای مربی‌ها، باشگاه‌ها و هیأت‌های ورزشی.
اون زمان تولید محتوای واقعی توی ورزش هنوز جا نیفتاده بود و سکانس اومد تا اون خلأ رو پر کنه.`,
      gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)',
      glowColor: '#4facfe',
      side: 'right',
    },
    {
      icon: <Hub />,
      date: '۸ دی ۱۴۰۲',
      title: 'ارتباط و نیازمندی‌ها | دیوار ورزشی',
      desc: `در ۸ دی ۱۴۰۲، کانال دیوار ورزشی شکل گرفت.
اینجا جایی بود برای اشتراک نیازهای ورزشی؛ باشگاه‌دار تجهیزات یا نیرو می‌خواست، مربی به دنبال همکار یا همکاری جدید بود و کسب‌وکارها می‌تونستن خدماتشون رو معرفی کنن.
یه پلتفرم واقعی برای به‌هم رسوندن اهالی ورزش و حل نیازهای روزمره‌شون.`,
      gradient: 'linear-gradient(135deg, #fa709a, #fee140)',
      glowColor: '#fa709a',
      side: 'left',
    },
    {
      icon: <Campaign />,
      date: '۲۸ اردیبهشت ۱۴۰۳',
      title: 'معرفی حرفه‌ای‌تر | igymm',
      desc: `در ۲۸ اردیبهشت ۱۴۰۳، پیج igymm ساخته شد تا مسیر معرفی مربیان و باشگاه‌ها جدی‌تر و هدفمندتر بشه.
ای‌جیم به مربی‌ها و باشگاه‌ها کمک می‌کرد با تبلیغات حرفه‌ای مخاطب هدف خودشون رو پیدا کنن.
igymm همون‌جایی بود که مربی شاگرد پیدا می‌کرد و باشگاه، مربی مناسبش رو؛ یه پل واقعی بین تلاش و دیده شدن.`,
      gradient: 'linear-gradient(135deg, #30cfd0, #330867)',
      glowColor: '#30cfd0',
      side: 'right',
    },
    {
      icon: <RocketLaunch />,
      date: 'فروردین ۱۴۰۳ تا امروز',
      title: 'از igymm تا آدین‌زون | شکل‌گیری برند واحد',
      desc: `در فروردین ۱۴۰۳، همه‌ی مسیرها یکی شدن و igymm تبدیل شد به آدین‌زون؛ چون وقتش بود این مسیر یه چهره‌ی واقعی، یه برند شخصی و قابل اعتماد داشته باشه.
من این مسیر رو تنها شروع کردم، ولی امروز آدین‌زون یه تیمه؛ یه خانواده از طراح‌ها، تولیدکننده‌های محتوا، مربی‌ها و آدم‌های باانگیزه که با هم کار می‌کنن تا ورزشکارها و باشگاه‌ها بهتر دیده بشن و قوی‌تر رشد کنن.
خانواده‌ی آدین‌زون هنوز داره بزرگ‌تر می‌شه:
🎵 آدین‌زون موزیک برای انرژی و انگیزه‌ی تمرین
🎬 آدین‌زون مدیا برای تولید محتوای تخصصی برندهای ورزشی
💻 سایت رسمی آدین‌زون برای معرفی مربیان، باشگاه‌ها و کسب‌وکارهای ورزشی در سراسر ایران
اینجا قراره دیده شدن، رشد کردن و اعتماد ساختن معنی واقعی پیدا کنه.
ما فقط یه سایت نیستیم؛ ما یه خانواده‌ایم از جنس ورزش، پیشرفت و همکاری.`,
      gradient: 'linear-gradient(135deg, #5c6bc0, #00e5ff)',
      glowColor: '#00e5ff',
      side: 'left',
    },
  ];

  const timelineGradient = `linear-gradient(
  180deg,
  transparent 0%,

  ${journeyItems[0].glowColor} 3%,
  ${journeyItems[0].glowColor} 14%,

  ${journeyItems[1].glowColor} 20%,
  ${journeyItems[1].glowColor} 30%,

  ${journeyItems[2].glowColor} 37%,
  ${journeyItems[2].glowColor} 47%,

  ${journeyItems[3].glowColor} 54%,
  ${journeyItems[3].glowColor} 64%,

  ${journeyItems[4].glowColor} 71%,
  ${journeyItems[4].glowColor} 81%,

  ${journeyItems[5].glowColor} 88%,
  ${journeyItems[5].glowColor} 97%,

  transparent 100%
)`;

  return (
    <Stack
      sx={{
        width: '100%',
        minWidth: 0,
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          textAlign: 'center',
          mb: {
            xs: 4,
            md: 6,
          },
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: '1.55rem',
              sm: '1.8rem',
              md: '2rem',
            },
            fontWeight: 800,
            mb: 1,
            background: `linear-gradient(
              135deg,
              ${theme.palette.primary.main},
              ${theme.palette.secondary.main},
              #FF6B6B
            )`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
          }}
        >
          سفر ماجراجویی ما
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: '0.78rem',
              sm: '0.85rem',
            },
            lineHeight: 1.9,
            color: 'text.secondary',
            maxWidth: 600,
            mx: 'auto',
          }}
        >
          داستان شکل‌گیری آدین‌زون؛ از یک نیاز ساده تا ساختن یک خانواده بزرگ
          ورزشی
        </Typography>
      </Box>

      {/* Timeline */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          minWidth: 0,
          py: 2,
          mb: 8,
        }}
      >
        {/* Continuous main line */}
        <Box
          sx={{
            position: 'absolute',
            right: '50%',
            top: 20,
            bottom: 20,
            width: 4,
            transform: 'translateX(50%)',

            display: {
              xs: 'none',
              md: 'block',
            },

            zIndex: 0,
            borderRadius: 10,
            background: timelineGradient,

            boxShadow: `
        0 0 8px ${alpha(theme.palette.primary.main, 0.35)},
        0 0 18px ${alpha(theme.palette.secondary.main, 0.2)}
      `,

            animation: 'timelineGlow 3s ease-in-out infinite',

            '@keyframes timelineGlow': {
              '0%, 100%': {
                opacity: 0.75,
                filter: 'brightness(0.9)',
              },
              '50%': {
                opacity: 1,
                filter: 'brightness(1.25)',
              },
            },
          }}
        />

        {/* Cards */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
          }}
        >
          {journeyItems.map((item, index) => (
            <ValueCard item={item} key={`${item.date}-${index}`} />
          ))}
        </Box>
      </Box>
    </Stack>
  );
}
